import React from 'react';
import { DNAButton, DNAText } from '@alucio/lux-ui';
import DNAPopover from 'src/components/DNA/Popover/DNAPopover';
import { useSidebar } from '../SidebarProvider';
import { styles } from '..';

const ShareButton: React.FC = () => {
  const { displayShareButton, onShare } = useSidebar();

  if (!displayShareButton) return null;
  return (
    <DNAPopover placement="left" disablePopover={['tabletPWA']}>
      <DNAPopover.Anchor>
        <DNAButton
          testID="share-icon"
          appearance="ghost"
          status="tertiary"
          size="lg"
          iconLeft="share-fat"
          onPress={onShare}
        />
      </DNAPopover.Anchor>
      <DNAPopover.Content>
        <DNAText style={styles.tooltipText} numberOfLines={1}>Share</DNAText>
      </DNAPopover.Content>
    </DNAPopover>
  )
}

export default ShareButton;
